import { gql } from '@apollo/client'

export const SignInAdminMutation = gql`
    mutation SignInAdmin($userName: String!, $password: String!) {
        signInAdmin (input: {
            userName: $userName,
            password: $password
        }){
            messages
            errorMessages
            isError
            result {
            token
            refreshToken
            }
        }
    }
`